import { Grid } from '@mui/material'
import CellHOC from '@platform/react/hoc/list/cell'
import Text from 'ui/Element/Text'
import { getSubLabel } from 'lib/util/string'

const styles = () => ({
  row: {
    gap: 12,
    flexWrap: 'nowrap',
  },
  subLabel: {
    gap: 4,
  },
})

/**
 * Displays the name of an article.
 *
 * @param {Object} classes  element's style classes
 * @param {Object} props    element's properties
 *
 * @returns {JSX.Element}
 */
export const ListItemCellDashboardArticleName = (classes, props = {}) => {
  const { label = '-', articleLabel, serialLong, info1 } = props
  const subLabel = getSubLabel(Text, [articleLabel, serialLong, info1])

  return (
    <Grid
      container
      direction={'row'}
      className={classes.row}
    >
      <Grid
        item
        xs={'auto'}
        alignSelf={'stretch'}
      >
        <Grid
          container
          gap={'0.125rem'}
          direction={'column'}
          alignItems={'flex-start'}
          justifyContent={'center'}

          sx={{ height: '100%' }}
        >
          <Text
            maxLines={1}
            value={label}
            variant={'14/bold'}
            color={'black.main'}
          />
          {articleLabel && (serialLong || info1) && (
            <Grid
              item
              container
              xs={'auto'}
              className={classes.subLabel}
            >
              {subLabel}
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  )
}

export default CellHOC(ListItemCellDashboardArticleName, styles)
